<template>
  <div class="pwdLogin">
    <a-form :form="loginForm" @submit="handleLogin">
      <a-form-item>
        <a-input placeholder="请输入手机号码" :maxLength="11" v-decorator="[
          'mobile',
          {
            rules: [
              { required: true, message: '请输入手机号' },
              { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确' }
            ],
            validateTrigger: 'none'
          }
        ]" />
      </a-form-item>
      <!-- TODO 密码缺少校验 -->
      <a-form-item>
        <div class="verify_box">
          <a-input placeholder="请输入验证码" :maxLength="6" v-decorator="['code', { rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'none' }]"></a-input>
          <button @click.stop.prevent="getCaptcha" class="verify_code">
            {{ state.send ? state.title : state.time + 's' }}
          </button>
        </div>
      </a-form-item>
      <form-footer></form-footer>
      <a-form-item>
        <a-button style="width: 370px;background: #4B7DFD;
border-radius: 6px;" size="large" type="primary" html-type="submit" :loading="loading">登录</a-button>
      </a-form-item>
    </a-form>
    <div v-show="pwdLoginModal" class="login-toast-modal">{{ errorMsg }}</div>
  </div>
</template>
<script>
import formFooter from './FormFooter.vue'
import { sendPhoneCodeNew, existMobile } from '@/api/system'
export default {
  name: 'VerifyCodeLogin',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loginForm: this.$form.createForm(this, { name: 'loginForm' }),
      checked: false,
      pwdLoginModal: false,
      errorMsg: '',
      timer: null,
      state: {
        title: '发送验证码',
        time: 60,
        send: true
      }
    }
  },
  created() {
    document.addEventListener('click', (e) => {
      if (e.target.className !== 'login-toast-modal' && this.pwdLoginModal) {
        this.closeLoginModal()
      }
    })
  },
  components: {
    formFooter
  },
  methods: {
    // 设置弹窗状态及提示msg
    setModal(status, msg) {
      if (!status) {
        this.closeLoginModal()
      } else {
        this.timer = setInterval(() => {
          this.closeLoginModal()
        }, 1000)
        this.pwdLoginModal = true
        this.errorMsg = msg
      }
    },
    handleLogin(e) {
      e.preventDefault()
      const rules = [
        { field: 'mobile', required: true, message: '请输入手机号码' },
        { field: 'code', required: true, message: '请输入验证码' },
        { field: 'mobile', pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确' },
      ]
      try {
        rules.forEach(v => {
          const fieldValue = this.loginForm.getFieldValue(v.field) || ''
          if (v.required) {
            if (fieldValue.trim().length === 0) {
              throw new Error(v.message)
            }
          } else if (v.pattern) {
            if (!v.pattern.test(fieldValue)) {
              throw new Error(v.message)
            }
          }
        })
      } catch (error) {
        this.setModal(true, error.message)
        return
      }
      const { mobile, code } = this.loginForm.getFieldsValue(['mobile', 'code'])
      this.$emit('login', { mobile, code, grant_type: 'stu_sms' })
      // this.loginForm.validateFields((error, values) => {
      //   if (error) return
      //   this.$emit('login', { ...values, grant_type: 'stu_sms' })
      // })
    },
    // 发送验证码
    async getCaptcha() {
      // this.loginForm.validateFields(async (error, values) => {
      // if (error || !this.state.send) return
      const telphone = this.loginForm.getFieldValue('mobile')
      const rules = [
        { field: 'mobile', required: true, message: '请输入手机号码' },
        { field: 'mobile', pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确' },
      ]
      try {
        rules.forEach(v => {
          const fieldValue = this.loginForm.getFieldValue(v.field) || ''
          if (v.required) {
            if (fieldValue.trim().length === 0) {
              throw new Error(v.message)
            }
          } else if (v.pattern) {
            if (!v.pattern.test(fieldValue)) {
              throw new Error(v.message)
            }
          }
        })
      } catch (error) {
        this.setModal(true, error.message)
        return
      }
      if (!this.state.send) {
        return
      }
      const isExist = await existMobile({
        orgCode: this.$ls.get('code') || '',
        mobile: telphone
      })
      if (!isExist) {
        this.setModal(true, '你尚未注册账号')
        return
      }
      const res = await sendPhoneCodeNew({ phoneNumber: telphone, ocode: this.$ls.get('code') })
      res && this.$message.success('发送成功，请注意查看')
      this.state.send = false
      this.timer = setInterval(() => {
        if (this.state.time-- <= 0) {
          this.state.title = '重新发送'
          this.state.time = 60
          this.state.send = true
          clearInterval(this.timer)
        }
      }, 1000)
      // console.log(telphone)
      // if (!telphone) {
      // // console.log(telphone, '123')
      //   // this.$message.error('请输入手机号')
      //   return
      // }
      // if (!this.state.send) {
      //   return
      // }
      // const res = await featchCode({ telphone })
      // res && this.$message.success('发送成功，请注意查看')
      // })
    },
    // 关闭局部登录模块局部弹窗
    closeLoginModal() {
      this.pwdLoginModal = false
      this.errorMsg = ''
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
  }
}
</script>
<style lang="less" scoped>
@import '../index.less';
.login-toast-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 248px;
  background: rgba(0,0,0,0.6);
  box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.1), 0px 8px 10px 1px rgba(0,0,0,0.06), 0px 3px 14px 2px rgba(0,0,0,0.05);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 5px 8px;
  word-break: break-all;
  color: #fff;
}
.verify_box {
  position: relative;
  .verify_code {
    position: absolute;
    right: 0;
    width: auto;
    line-height: 45px;
    padding: 0 18px;
    cursor: pointer;
    background: none;
    border: none;
    color: #1564ff;
    z-index: 2;
  }
}
.loginIsRegister {
  padding-bottom: 34px;
  margin-bottom: 12px;
  border-bottom: 1px solid #d6dae3;
}
.ant-form-item {
  display: flex;
  width: 100%;
  margin-bottom: 19px;
  &.ant-form-item-with-help {
    margin-bottom: 0;
  }
  .input-box {
    display: flex;
    align-items: center;
  }

  /deep/ .ant-form-item-label {
    line-height: 48px;
  }
  // align-items: center;
  /deep/ .ant-form-item-control-wrapper {
    width: 100%;
    .ant-form-item-control {
      height: 100%;
      .ant-form-explain {
        font-size: 12px;
        line-height: 22px;
        padding: 0;
      }
    }
    .iconStyle {
      width: 16px;
      height: 16px;
      position: absolute;
      right: 10px;
      top: 0px;
    }
    input {
      box-sizing: border-box;
      width: 370px;
      height: 48px;
      background: #f5f8fa;
      border-radius: 6px;
      padding-right: 30px;
      font-size: 14px;
    }
  }
}
</style>
